import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgCustomizableSliderComponent } from './customizable-slider.component';
import { NgSliderElementDirective } from './directives/slider-element.directive';
import { NgSliderHandleDirective } from './directives/slider-handle.directive';
import { NgSliderLabelDirective } from './directives/slider-label.directive';
import { NgTooltipWrapperComponent } from './tooltip-wrapper/tooltip-wrapper.component';
import { CustomizableSliderHelper } from './shared/customizable-slider.helper';


@NgModule({
	declarations: [
		NgCustomizableSliderComponent,
		NgSliderElementDirective,
		NgSliderHandleDirective,
		NgSliderLabelDirective,
		NgTooltipWrapperComponent
	],
	imports: [
		CommonModule
	],
	exports: [
		NgCustomizableSliderComponent
	],
	providers: [
		CustomizableSliderHelper
	]
})
export class NgCustomizableSliderModule { }
